export default "__VITE_ASSET__8e282603__"